import { render, staticRenderFns } from "./SimilarStartup.vue?vue&type=template&id=3a95024f&scoped=true&"
import script from "./SimilarStartup.vue?vue&type=script&lang=js&"
export * from "./SimilarStartup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a95024f",
  null
  
)

export default component.exports